import { render, staticRenderFns } from "./TasaDespachoBodegaVuelo.vue?vue&type=template&id=7f2350ca&"
import script from "./TasaDespachoBodegaVuelo.vue?vue&type=script&lang=js&"
export * from "./TasaDespachoBodegaVuelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
